import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import moment from 'moment';
import { Modal, Button } from 'react-bootstrap';
import { Checkbox, MenuItem } from '@mui/material';
import _ from 'lodash';

import { stateReports } from '../../../../services/clinicPortalServices/reportService';
import {
    getViewSettings,
    saveOrderSettings,
    deleteGridViewService,
    renameGridViewService,
    updateGridViewService
} from '../../../../services/clinicPortalServices/userViewSettings';
import { dateComparator, getUserDetails } from '../../../../services/common/util';
import ReportsSearchMenu from './ReportsSearchMenu';
import AllGridViews from '../../orders/clinicOrderGrid/allGridViews';
import { settingConstants } from '../../../../services/common/optionsData';
import toastr from 'toastr';
import Swal from 'sweetalert2';
import { createAudit } from '../../../../services/clinicPortalServices/auditService';
import { auditEnums } from '../../../../services/common/constants';
import { ThemeContext } from '../../../../theme/ThemeProvider';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';
import { colorSchemeDark, colorSchemeLight, themeQuartz } from 'ag-grid-community';

const themeLight = themeQuartz.withPart(colorSchemeLight);
const themeDark = themeQuartz.withPart(colorSchemeDark);

class ClinicStateReportsGrid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            quickFilterText: '',
            isDateSave: false,
            showAllGridViews: false,
            isCreateDefault: true,
            isRenameView: false,
            isUpdateViews: false,
            showNameModal: false,
            newViewName: '',
            userId: window.localStorage.getItem('USER_ID'),
            selectedViewId: null,
            userSetting: {
                user_id: window.localStorage.getItem('USER_ID'),
                type: settingConstants.GRID,
                page: settingConstants.STATE_REPORTS,
                grid_views: []
            },
            activeGridView: {
                _id: 0,
                name: '',
                search_filters: {
                    from_date: moment().subtract(0, 'days').format('YYYY-MM-DD') + 'T00:00',
                    to_date: moment().add(1, 'days').format('YYYY-MM-DD') + 'T00:00',
                    dateRange: 'today',
                    stateReportsType: 'ALL'
                },
                page_size: settingConstants.DEFAULT_PAGESIZE,
                columns: [],
                date_save: false
            },
            defaultGridView: {
                name: settingConstants.DEFAULT_VIEWNAME,
                search_filters: {
                    from_date: moment().subtract(0, 'days').format('YYYY-MM-DD') + 'T00:00',
                    to_date: moment().add(1, 'days').format('YYYY-MM-DD') + 'T00:00',
                    dateRange: 'today',
                    stateReportsType: 'ALL'
                },
                page_size: settingConstants.DEFAULT_PAGESIZE,
                columns: [],
                date_save: false
            },
            columnDefs: [
                {
                    headerName: 'Test_Name',
                    minWidth: 200,
                    resizable: true,
                    field: 'test_id.name'
                },
                {
                    headerName: 'Result',
                    minWidth: 200,
                    resizable: true,
                    valueGetter: function addColumns(params) {
                        if (params.data.results.value === 'Positive SARS-CoV-2') {
                            return 'Detected';
                        } else if (params.data.results.value === 'SARS-CoV-2 Not Detected') {
                            return 'Not Detected';
                        } else if (params.data.results.value === 'SARS-CoV-2 Inconclusive') {
                            return 'Inconclusive';
                        } else if (params.data.results.value === 'SARS-CoV-2 POSITIVE') {
                            return 'Detected';
                        } else if (params.data.results.value === 'SARS-CoV-2 NEGATIVE') {
                            return 'Not Detected';
                        } else if (params.data.results.value === 'SARS-CoV-2 INVALID') {
                            return 'Invalid Result';
                        }
                    }
                },
                {
                    headerName: 'Unit',
                    minWidth: 80,
                    resizable: true
                },
                {
                    headerName: 'Order_Number',
                    field: 'lab_order_id',
                    minWidth: 150,
                    resizable: true
                },
                {
                    headerName: 'Collect_Date',
                    field: 'test_info.collected',
                    minWidth: 200,
                    resizable: true,
                    valueGetter: function addColumns(params) {
                        return params.data.test_info && params.data.test_info.collected
                            ? moment(params.data.test_info.collected, 'YYYYMMDDHHmmss').format('MM/DD/YYYY')
                            : '';
                    },
                    comparator: dateComparator
                },
                {
                    headerName: 'Date_Verified',
                    field: 'results.released',
                    minWidth: 200,
                    resizable: true,
                    valueGetter: function addColumns(params) {
                        return params.data.results.released
                            ? moment(params.data.results.released, 'YYYYMMDDHHmmss').format('MM/DD/YYYY')
                            : '';
                    },
                    comparator: dateComparator
                },
                {
                    headerName: 'Pt_Number',
                    field: 'patient_id.mrn',
                    minWidth: 150,
                    resizable: true
                },
                {
                    headerName: 'Pt_Fname',
                    field: 'patient_id.first_name',
                    minWidth: 150,
                    resizable: true
                },
                {
                    headerName: 'Pt_Lname',
                    field: 'patient_id.last_name',
                    minWidth: 150,
                    resizable: true
                },
                {
                    headerName: 'Date_of_Birth',
                    field: 'patient_id.date_of_birth',
                    minWidth: 200,
                    resizable: true,
                    valueGetter: function addColumns(params) {
                        return params.data.patient_id.date_of_birth
                            ? moment(params.data.patient_id.date_of_birth, 'YYYY-MM-DD').format('MM/DD/YYYY')
                            : '';
                    },
                    comparator: dateComparator
                },
                {
                    headerName: 'Sex',
                    field: 'patient_id.gender',
                    minWidth: 100,
                    resizable: true
                },
                {
                    headerName: 'Pt_Race',
                    field: 'patient_id.race',
                    minWidth: 150,
                    resizable: true
                },
                {
                    headerName: 'Pt_Phone',
                    field: 'patient_id.mobile',
                    minWidth: 150,
                    resizable: true
                },
                {
                    headerName: 'Pt_St1',
                    field: 'patient_id.address.address1',
                    minWidth: 250,
                    resizable: true
                },
                {
                    headerName: 'Pt_St2',
                    field: 'patient_id.address.address2',
                    minWidth: 150,
                    resizable: true
                },
                {
                    headerName: 'Pt_City',
                    field: 'patient_id.address.city',
                    minWidth: 150,
                    resizable: true
                },
                {
                    headerName: 'Pt_ST',
                    field: 'patient_id.address.state',
                    minWidth: 150,
                    resizable: true
                },
                {
                    headerName: 'Pt_Zip',
                    field: 'patient_id.address.zip',
                    minWidth: 150,
                    resizable: true
                },
                {
                    headerName: 'Ordering_Facility',
                    field: 'facility_source',
                    minWidth: 250,
                    resizable: true
                },
                {
                    headerName: 'Last Name, First Name',
                    minWidth: 250,
                    resizable: true,
                    valueGetter: function addColumns(params) {
                        if (params.data.provider) {
                            return params.data.provider.last_name + ', ' + params.data.provider.first_name;
                        }
                    }
                },
                {
                    headerName: 'Dt_St1',
                    minWidth: 250,
                    resizable: true,
                    valueGetter: function addColumns(params) {
                        if (
                            params.data.provider &&
                            params.data.provider.address &&
                            params.data.provider.address.address1
                        ) {
                            return params.data.provider.address.address1;
                        } else {
                            return params.data.facility_id.address ? params.data.facility_id.address.address1 : '';
                        }
                    }
                },
                {
                    headerName: 'Dt_St2',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: function addColumns(params) {
                        if (
                            params.data.provider &&
                            params.data.provider.address &&
                            params.data.provider.address.address2
                        ) {
                            return params.data.provider.address.address2;
                        } else {
                            return params.data.facility_id.address ? params.data.facility_id.address.address2 : '';
                        }
                    }
                },
                {
                    headerName: 'Dt_City',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: function addColumns(params) {
                        if (params.data.provider && params.data.provider.address && params.data.provider.address.city) {
                            return params.data.provider.address.city;
                        } else {
                            return params.data.facility_id.address ? params.data.facility_id.address.city : '';
                        }
                    }
                },
                {
                    headerName: 'Dt_ST',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: function addColumns(params) {
                        if (
                            params.data.provider &&
                            params.data.provider.address &&
                            params.data.provider.address.state
                        ) {
                            return params.data.provider.address.state;
                        } else {
                            return params.data.facility_id.address ? params.data.facility_id.address.state : '';
                        }
                    }
                },
                {
                    headerName: 'Dt_Zip',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: function addColumns(params) {
                        if (params.data.provider && params.data.provider.address && params.data.provider.address.zip) {
                            return params.data.provider.address.zip;
                        } else {
                            return params.data.facility_id.address ? params.data.facility_id.address.zip : '';
                        }
                    }
                },
                {
                    headerName: 'Dt_Ph',
                    field: 'provider.mobile',
                    minWidth: 150,
                    resizable: true
                },
                {
                    headerName: 'Ref_range',
                    minWidth: 200,
                    resizable: true,
                    valueGetter: function addColumns(params) {
                        if (params.data.results.value === 'Positive SARS-CoV-2') {
                            return 'Detected';
                        } else if (params.data.results.value === 'SARS-CoV-2 Not Detected') {
                            return 'Not Detected';
                        } else if (params.data.results.value === 'SARS-CoV-2 Inconclusive') {
                            return 'Inconclusive';
                        } else if (params.data.results.value === 'SARS-CoV-2 POSITIVE') {
                            return 'Detected';
                        } else if (params.data.results.value === 'SARS-CoV-2 NEGATIVE') {
                            return 'Not Detected';
                        } else if (params.data.results.value === 'SARS-CoV-2 INVALID') {
                            return 'Invalid Result';
                        }
                    }
                },
                {
                    headerName: 'Specimen_Source',
                    field: 'test_info.test_type',
                    minWidth: 200,
                    resizable: true
                },
                {
                    headerName: 'Reporting_Facility',
                    minWidth: 250,
                    resizable: true,
                    valueGetter: function addColumns(params) {
                        return 'BenchLab, LLC. Inc.';
                    }
                },
                {
                    headerName: 'Reporting_CLIA',
                    minWidth: 200,
                    resizable: true,
                    valueGetter: function addColumns(params) {
                        return '21D2206868';
                    }
                },
                {
                    headerName: 'Order_Date',
                    field: 'order_date',
                    minWidth: 200,
                    resizable: true,
                    valueGetter: function addColumns(params) {
                        return params.data.order_date
                            ? moment(params.data.order_date, 'YYYYMMDDHHmmss').format('MM/DD/YYYY')
                            : '';
                    },
                    comparator: dateComparator
                },
                {
                    headerName: 'Test_Code',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: function addColumns(params) {
                        return '94500-6';
                    }
                },
                {
                    headerName: 'Result_Code',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: function addColumns(params) {
                        if (params.data.results.value === 'Positive SARS-CoV-2') {
                            return '260373001';
                        } else if (params.data.results.value === 'SARS-CoV-2 Not Detected') {
                            return '260415000';
                        } else if (params.data.results.value === 'SARS-CoV-2 Inconclusive') {
                            return '419984006';
                        } else if (params.data.results.value === 'SARS-CoV-2 POSITIVE') {
                            return '260373001';
                        } else if (params.data.results.value === 'SARS-CoV-2 NEGATIVE') {
                            return '260415000';
                        } else if (params.data.results.value === 'SARS-CoV-2 INVALID') {
                            return '455371000124106';
                        }
                    }
                },
                {
                    headerName: 'Device Identifier',
                    minWidth: 160,
                    resizable: true
                },
                {
                    headerName: 'Pt_Ethnicity',
                    field: 'patient_id.ethnicity',
                    minWidth: 150,
                    resizable: true
                },
                {
                    headerName: 'Ordering_Provider_NPI',
                    field: 'provider.npi',
                    minWidth: 200,
                    resizable: true
                },
                {
                    headerName: 'Patient_County',
                    field: 'patient_id.county',
                    minWidth: 150,
                    resizable: true
                },
                {
                    headerName: 'Performing_Facility',
                    minWidth: 250,
                    resizable: true,
                    valueGetter: function addColumns(params) {
                        return 'BenchLab, LLC. Inc.';
                    }
                },
                {
                    headerName: 'Performing_Facility_CLIA',
                    minWidth: 250,
                    resizable: true,
                    valueGetter: function addColumns(params) {
                        return '21D2206868';
                    }
                },
                {
                    headerName: 'Performing_Facility_Zip',
                    minWidth: 250,
                    resizable: true,
                    valueGetter: function addColumns(params) {
                        return '20850';
                    }
                },
                {
                    headerName: 'First_test',
                    minWidth: 150,
                    resizable: true
                },
                {
                    headerName: 'Healthcare_Worker',
                    minWidth: 150,
                    resizable: true
                },
                {
                    headerName: 'Symptomatic',
                    minWidth: 150,
                    resizable: true
                },
                {
                    headerName: 'Symptom_Onset',
                    minWidth: 150,
                    resizable: true
                },
                {
                    headerName: 'Hospitalized',
                    minWidth: 150,
                    resizable: true
                },
                {
                    headerName: 'ICU',
                    minWidth: 100,
                    resizable: true
                },
                {
                    headerName: 'Congregate_Care_Setting',
                    minWidth: 200,
                    resizable: true
                },
                {
                    headerName: 'Pregnant',
                    minWidth: 120,
                    resizable: true,
                    valueGetter: function addColumns(params) {
                        if (params.data.patient_id.is_pregnant) {
                            return 'Yes';
                        } else {
                            return 'No';
                        }
                    }
                }
            ],
            paginationNumberFormatter: function (params) {
                return '[' + params.value.toLocaleString() + ']';
            },
            defaultColDef: {
                flex: 1,
                filter: true,
                sortable: true
            },
            rowData: [],
            excelStyles: [
                {
                    id: 'header',
                    interior: {
                        color: '#aaaaaa',
                        pattern: 'Solid'
                    }
                },
                {
                    id: 'body',
                    interior: {
                        color: '#dddddd',
                        pattern: 'Solid'
                    }
                }
            ]
        };
    }

    componentDidMount() {
        this.loadUserSetting(this.state.defaultGridView);
    }

    initDateRange = (grid_views) => {
        return grid_views.map((view) => {
            if (
                moment(view.search_filters.to_date).format('YYYY-MM-DD') ===
                moment().add(1, 'days').format('YYYY-MM-DD')
            ) {
                if (moment(view.search_filters.from_date).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')) {
                    view.search_filters.dateRange = 'today';
                } else if (
                    moment(view.search_filters.from_date).format('YYYY-MM-DD') ===
                    moment().startOf('week').format('YYYY-MM-DD')
                ) {
                    view.search_filters.dateRange = 'week';
                } else if (
                    moment(view.search_filters.from_date).format('YYYY-MM-DD') ===
                    moment().startOf('month').format('YYYY-MM-DD')
                ) {
                    view.search_filters.dateRange = 'month';
                } else if (
                    moment(view.search_filters.from_date).format('YYYY-MM-DD') ===
                    moment().startOf('quarter').format('YYYY-MM-DD')
                ) {
                    view.search_filters.dateRange = 'quarter';
                } else {
                    view.search_filters.dateRange = 'custom';
                }
            } else {
                view.search_filters.dateRange = 'custom';
            }
            return view;
        });
    };

    loadUserSetting = (defaultGridView) => {
        let { userId, userSetting } = this.state;
        let viewId = '',
            activeGridView = null;
        let params = {
            user_id: userId,
            type: settingConstants.GRID,
            page: settingConstants.STATE_REPORTS
        };
        getViewSettings(params).then((response) => {
            if (response.data && response.data.length > 0) {
                userSetting = response.data[0];
                if (userSetting.grid_views.length > 0) {
                    viewId = window.localStorage.getItem('VIEW_STATE_REPORTS');
                    userSetting.grid_views = this.initDateRange(userSetting.grid_views);
                    let activeGridViewTemp = viewId ? userSetting.grid_views.find((x) => x._id === viewId) : null;
                    activeGridView = activeGridViewTemp
                        ? _.cloneDeep(activeGridViewTemp)
                        : _.cloneDeep(userSetting.grid_views[0]);
                    window.localStorage.setItem('VIEW_STATE_REPORTS', activeGridView._id);
                    if (activeGridView.name === 'Default') {
                        activeGridView.search_filters = _.cloneDeep(defaultGridView.search_filters);
                    } else if (!activeGridView.date_save) {
                        activeGridView.search_filters.from_date = _.cloneDeep(defaultGridView.search_filters.from_date);
                        activeGridView.search_filters.to_date = _.cloneDeep(defaultGridView.search_filters.to_date);
                    }
                    this.setState({
                        activeGridView: activeGridView,
                        userSetting: userSetting
                    });
                    this.loadGridData(activeGridView.search_filters);
                } else {
                    this.createView(settingConstants.DEFAULT_VIEWNAME);
                }
            } else {
                this.createView(settingConstants.DEFAULT_VIEWNAME);
            }
        });
    };

    handleTabChange = (selectedViewId) => {
        let { activeGridView, defaultGridView, userSetting } = this.state;
        if (selectedViewId !== activeGridView._id && !selectedViewId.includes('_btn')) {
            let selectedGridView = userSetting.grid_views.find((view) => view._id === selectedViewId);
            window.localStorage.setItem('VIEW_STATE_REPORTS', selectedViewId);
            if (selectedGridView.name === 'Default')
                selectedGridView.search_filters = _.cloneDeep(defaultGridView.search_filters);
            else if (!activeGridView.date_save) {
                activeGridView.search_filters.from_date = _.cloneDeep(defaultGridView.search_filters.from_date);
                activeGridView.search_filters.to_date = _.cloneDeep(defaultGridView.search_filters.to_date);
            }
            this.setState({ activeGridView: _.cloneDeep(selectedGridView) });
            this.loadGridData(selectedGridView.search_filters);
        }
    };

    updateDateRange = (dateRange) => {
        let { activeGridView } = this.state;
        let filters = activeGridView.search_filters;
        if (activeGridView.search_filters.dateRange !== dateRange) {
            switch (dateRange) {
                case 'today':
                    filters.to_date = moment().add(1, 'days').format('YYYY-MM-DD') + 'T00:00';
                    filters.from_date = moment().format('YYYY-MM-DD') + 'T00:00';
                    activeGridView.search_filters.dateRange = dateRange;
                    break;
                case 'week':
                    filters.to_date = moment().add(1, 'days').format('YYYY-MM-DD') + 'T00:00';
                    filters.from_date = moment().startOf('week').format('YYYY-MM-DD') + 'T00:00';
                    activeGridView.search_filters.dateRange = dateRange;
                    break;
                case 'month':
                    filters.to_date = moment().add(1, 'days').format('YYYY-MM-DD') + 'T00:00';
                    filters.from_date = moment().startOf('month').format('YYYY-MM-DD') + 'T00:00';
                    activeGridView.search_filters.dateRange = dateRange;
                    break;
                case 'quarter':
                    filters.to_date = moment().add(1, 'days').format('YYYY-MM-DD') + 'T00:00';
                    filters.from_date = moment().startOf('quarter').format('YYYY-MM-DD') + 'T00:00';
                    activeGridView.search_filters.dateRange = dateRange;
                    break;
                default:
                    break;
            }
            this.setState({ activeGridView });
            if (dateRange !== 'custom') {
                this.loadGridData(filters);
            }
        }
    };

    setDateRange = (gridView) => {
        if (
            moment(gridView.search_filters.to_date).format('YYYY-MM-DD') ===
            moment().add(1, 'days').format('YYYY-MM-DD')
        ) {
            if (moment(gridView.search_filters.from_date).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')) {
                gridView.search_filters.dateRange = 'today';
            } else if (
                moment(gridView.search_filters.from_date).format('YYYY-MM-DD') ===
                moment().startOf('week').format('YYYY-MM-DD')
            ) {
                gridView.search_filters.dateRange = 'week';
            } else if (
                moment(gridView.search_filters.from_date).format('YYYY-MM-DD') ===
                moment().startOf('month').format('YYYY-MM-DD')
            ) {
                gridView.search_filters.dateRange = 'month';
            } else if (
                moment(gridView.search_filters.from_date).format('YYYY-MM-DD') ===
                moment().startOf('quarter').format('YYYY-MM-DD')
            ) {
                gridView.search_filters.dateRange = 'quarter';
            } else {
                gridView.search_filters.dateRange = 'custom';
            }
        } else {
            gridView.search_filters.dateRange = 'custom';
        }
    };

    handleDateFiltersChange = (dateTime, type) => {
        let { activeGridView } = this.state;
        const filters = activeGridView.search_filters;
        let filterIsValid = true;
        if (type === 'from_date') {
            if (moment(filters.to_date).isAfter(dateTime)) {
                filters.from_date = dateTime;
            } else {
                filterIsValid = false;
            }
        } else {
            if (moment(dateTime).isAfter(filters.from_date)) {
                filters.to_date = dateTime;
            } else {
                filterIsValid = false;
            }
        }

        if (filterIsValid) {
            this.setDateRange(activeGridView);
            this.setState({ activeGridView });
            this.loadGridData(filters);
        }
    };

    handleFiltersChange = (e) => {
        let { activeGridView } = this.state;
        let filters = activeGridView.search_filters;

        switch (e.target.name) {
            case 'type':
                filters.stateReportsType = e.target.value;
                break;
            default:
                break;
        }

        this.setState({ activeGridView });
        this.loadGridData(filters);
    };

    onGridReady = (params) => {
        let { defaultGridView } = this.state;
        this.gridApi = params.api;
        defaultGridView.columns = this.gridApi.getColumnState();
        this.setState({ defaultGridView });
    };

    loadGridData = (searchFilterConditions = null) => {
        let searchFilters;
        if (!searchFilterConditions) {
            searchFilters = this.state.activeGridView.search_filters;
        } else {
            searchFilters = searchFilterConditions;
        }
        if (this.gridApi) {
            this.gridApi.showLoadingOverlay();
        }
        stateReports(searchFilters).then((response) => {
            this.setState({ rowData: response.data });
            if (!response.data.length) {
                this.gridApi.showNoRowsOverlay();
            } else {
                this.gridApi.hideOverlay();
            }
            this.loadGridSchema();
        });
    };

    loadGridSchema = () => {
        let { activeGridView } = this.state;
        const columnState = activeGridView.columns;
        if (columnState && columnState.length > 0 && activeGridView.name !== 'Default') {
            this.gridApi.applyColumnState({
                state: columnState,
                applyOrder: true
            });
        } else {
            this.gridApi.resetColumnState();
            activeGridView.columns = this.gridApi.getColumnState();
            this.setState({ activeGridView });
        }
        this.pageSizeChange(activeGridView.page_size);
    };

    onFilterTextChange = (e) => {
        this.setState({ quickFilterText: e.target.value });
    };

    onBtnExport = () => {
        this.gridApi.exportDataAsExcel({
            fileName: 'State_Report_Grid_' + moment().format('YYYY_MM_DD_HH_mm_ss') + '.xlsx',
            sheetName: 'State Report'
        });
        const userData = JSON.parse(getUserDetails());
        const auditData = {
            identifier: auditEnums.IDENTIFIERS.ExportRecord,
            event_type: auditEnums.EVENTTYPES.StateReportGridExported,
            user_id: userData._id,
            user_name: userData.user_name + ' (' + userData.role + ')',
            update_string: auditEnums.EVENTTYPES.StateReportGridExported
        };
        createAudit(auditData);
    };

    onPageSizeChanged = (e) => {
        this.pageSizeChange(e.target.value);
    };

    pageSizeChange = (pageSize) => {
        let { activeGridView } = this.state;
        activeGridView.page_size = pageSize;
        this.setState({ activeGridView });
    };

    resetState = () => {
        this.pageSizeChange(settingConstants.DEFAULT_PAGESIZE);
        this.clearFilter();
    };

    clearFilter = () => {
        let { activeGridView, defaultGridView } = this.state;
        let viewInfoPrev = _.cloneDeep(activeGridView);
        activeGridView = _.cloneDeep(defaultGridView);
        if (viewInfoPrev._id) {
            activeGridView._id = viewInfoPrev._id;
        }
        activeGridView.name = viewInfoPrev.name;
        this.gridApi.setFilterModel(null);
        this.setState({
            activeGridView,
            quickFilterText: ''
        });
        document.getElementById('reset-form').value = '';
        this.loadGridData(activeGridView.search_filters);
    };

    openCreateView = (isCreateDefault) => {
        this.setState({
            showNameModal: true,
            isCreateDefault,
            isRenameView: false
        });
    };

    saveView = () => {
        let { isRenameView, newViewName } = this.state;
        if (isRenameView) {
            this.renameView(newViewName);
        } else {
            this.createView(newViewName);
        }
    };

    updateView = () => {
        let { activeGridView, userSetting } = this.state;
        activeGridView.columns = this.gridApi.getColumnState();
        let viewInfo = {
            _id: userSetting._id,
            grid_view: activeGridView
        };
        Swal.fire({
            title: 'Save Current Dates?',
            text: 'Do you want to save the current dates?',
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            customClass: {
                container:
                    window.localStorage.getItem('appTheme') === 'Dark' &&
                    /clinic|lims/.test(window.location.pathname.split('/')[1]) &&
                    'dark-swal',
                cancelButton: 'order-1',
                confirmButton: 'order-2'
            },
            allowOutsideClick: false
        }).then((result) => {
            activeGridView.date_save = result.isConfirmed ? true : false;
            updateGridViewService(viewInfo).then((response) => {
                if (response.status === 200) {
                    userSetting = response.data;
                    userSetting.grid_views = this.initDateRange(userSetting.grid_views);
                    this.setState({ userSetting });
                    toastr.success('View saved successfully.');
                    this.handleClose();
                } else {
                    toastr.error('Error');
                }
            });
        });
    };

    createView = (newName) => {
        let newGridView = {};
        let { activeGridView, defaultGridView, userSetting, isCreateDefault, isDateSave } = this.state;
        let isNameExists = userSetting.grid_views.some((view) => view.name === newName);
        if (!isNameExists) {
            if (isCreateDefault) {
                newGridView = _.cloneDeep(defaultGridView);
            } else {
                newGridView = _.cloneDeep(activeGridView);
                delete newGridView._id;
            }
            newGridView.name = newName;
            newGridView.date_save = isDateSave;
            if (isDateSave) {
                newGridView.search_filters.from_date = _.cloneDeep(activeGridView.search_filters.from_date);
                newGridView.search_filters.to_date = _.cloneDeep(activeGridView.search_filters.to_date);
            } else {
                newGridView.search_filters.from_date = _.cloneDeep(defaultGridView.search_filters.from_date);
                newGridView.search_filters.to_date = _.cloneDeep(defaultGridView.search_filters.to_date);
            }
            userSetting.grid_views.push(newGridView);
            this.saveState(userSetting);
        } else {
            toastr.warning('Same name exists.');
        }
    };

    updateViews = (gridViews) => {
        let { userSetting } = this.state;
        userSetting.grid_views = gridViews;
        this.setState({ isUpdateViews: true });
        this.saveState(userSetting);
    };

    saveState = (gridSetting) => {
        saveOrderSettings(gridSetting).then((response) => {
            if (response.status === 200) {
                let { isUpdateViews, activeGridView } = this.state;
                let userSetting = response.data;
                userSetting.grid_views = this.initDateRange(userSetting.grid_views);
                if (!isUpdateViews) {
                    let lastGridViewIndex = userSetting.grid_views.length - 1;
                    activeGridView = _.cloneDeep(userSetting.grid_views[lastGridViewIndex]);
                    window.localStorage.setItem('VIEW_STATE_REPORTS', activeGridView._id);
                    this.setState({
                        activeGridView,
                        userSetting,
                        isCreateDefault: true
                    });
                    this.loadGridData(activeGridView.search_filters);
                    if (activeGridView.name !== 'Default') toastr.success('Settings saved successfully.');
                } else {
                    this.setState({
                        activeGridView,
                        userSetting,
                        isUpdateViews: false
                    });
                }

                this.handleClose();
            } else if (response.status === 403) {
                toastr.error(response.message);
            } else {
                toastr.error('Error');
            }
        });
    };

    handleClose = () => {
        this.setState({
            showNameModal: false,
            newViewName: '',
            isDateSave: false
        });
    };

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    renameActiveView = () => {
        let { activeGridView } = this.state;
        this.setState({ newViewName: activeGridView.name });
        this.openRenameView(activeGridView._id);
    };

    openRenameView = (selectedViewId) => {
        let { userSetting } = this.state;
        let selectedView = userSetting.grid_views.find((view) => view._id === selectedViewId);
        this.setState({
            isRenameView: true,
            showNameModal: true,
            selectedViewId,
            newViewName: selectedView.name
        });
    };

    toggleItem = (name) => {
        this.setState({ [name]: !this.state[name] });
    };

    renameView = () => {
        let { selectedViewId, userSetting, newViewName } = this.state;
        let isNameExists = userSetting.grid_views.some(
            (view) => view.name === newViewName && view._id !== selectedViewId
        );
        if (isNameExists) {
            toastr.warning('Same name exists.');
        } else {
            let viewInfo = {
                _id: userSetting._id,
                view_id: selectedViewId,
                view_name: newViewName
            };
            renameGridViewService(viewInfo).then((response) => {
                if (response.status === 200) {
                    userSetting = response.data;
                    userSetting.grid_views = this.initDateRange(userSetting.grid_views);
                    let activeGridView = _.cloneDeep(
                        userSetting.grid_views.find((view) => view._id === selectedViewId)
                    );
                    this.setState({
                        userSetting,
                        activeGridView,
                        isRenameView: false
                    });
                    toastr.success('View renamed successfully.');
                    this.handleClose();
                } else {
                    toastr.error('Error');
                }
            });
        }
    };

    deleteActiveView = () => {
        let { activeGridView } = this.state;
        this.openDeleteView(activeGridView._id);
    };

    openDeleteView = (viewId) => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this view!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it',
            customClass: {
                container:
                    window.localStorage.getItem('appTheme') === 'Dark' &&
                    /clinic|lims/.test(window.location.pathname.split('/')[1]) &&
                    'dark-swal',
                cancelButton: 'order-1',
                confirmButton: 'order-2'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                this.deleteView(viewId);
            }
        });
    };

    deleteView = (viewId) => {
        let { userSetting } = this.state;
        const viewInfo = {
            _id: userSetting._id,
            view_id: viewId
        };
        deleteGridViewService(viewInfo).then((response) => {
            if (response.status === 200) {
                userSetting = response.data;
                let newActiveGridView = userSetting.grid_views[0];
                this.setState({ userSetting });
                this.handleTabChange(newActiveGridView._id);
                toastr.success('View deleted successfully.');
                this.handleClose();
            } else {
                toastr.error('Error');
            }
        });
    };

    handleKeyDown = (e) => {
        if (e.which === 13) {
            e.preventDefault();
            this.saveView();
        }
    };

    openAllGridViews = (isOpen) => {
        this.setState({ showAllGridViews: isOpen });
    };

    render() {
        const { showAllGridViews, newViewName, activeGridView, isCreateDefault, isRenameView, userSetting, showNameModal } =
            this.state;
        return (
            <div className="clinic-contain">
                <ReportsSearchMenu
                    handleFiltersChange={this.handleFiltersChange}
                    handleDateFiltersChange={this.handleDateFiltersChange}
                    updateDateRange={this.updateDateRange}
                    from_date={activeGridView.search_filters.from_date}
                    to_date={activeGridView.search_filters.to_date}
                    date_range={activeGridView.search_filters.dateRange}
                    onFilterTextChange={this.onFilterTextChange}
                    stateReportsType={activeGridView.search_filters.stateReportsType}
                    clearFilter={this.clearFilter}
                    onPageSizeChanged={this.onPageSizeChanged}
                    page_size={activeGridView.page_size}
                    resetState={this.resetState}
                    onBtnExport={this.onBtnExport}
                    gridViews={userSetting.grid_views}
                    activeGridView={activeGridView}
                    openCreateView={this.openCreateView}
                    handleTabChange={this.handleTabChange}
                    updateView={this.updateView}
                    openAllGridViews={this.openAllGridViews}
                    renameActiveView={this.renameActiveView}
                    deleteActiveView={this.deleteActiveView}
                />
                <div
                    style={{
                        width: '100%',
                        height: 'calc(100vh - 350px)',
                        padding: '15px'
                    }}
                >
                    <ThemeContext.Consumer>
                        {({ themeName }) => (
                            <div
                                id="myGrid"
                                style={{
                                    height: '100%',
                                    width: '100%'
                                }}
                            >
                                <AgGridReact
                                    columnDefs={this.state.columnDefs}
                                    defaultColDef={this.state.defaultColDef}
                                    masterDetail={true}
                                    onGridReady={this.onGridReady}
                                    rowData={this.state.rowData}
                                    components={this.state.components}
                                    pagination={true}
                                    paginationPageSize={activeGridView.page_size}
                                    paginationNumberFormatter={this.state.paginationNumberFormatter}
                                    paginationPageSizeSelector={false}
                                    excelStyles={this.state.excelStyles}
                                    theme={themeName === 'Light' ? themeLight : themeDark}
                                    quickFilterText={this.state.quickFilterText}
                                />
                            </div>
                        )}
                    </ThemeContext.Consumer>
                </div>

                {/* Create modal */}
                <ModalStyled show={showNameModal} onHide={this.handleClose} backdrop="static">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {isRenameView
                                ? 'Update Name'
                                : 'Create a new ' + (isCreateDefault ? '' : ' saved') + ' view'}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-12">
                                <label>
                                    Name <span className="text-danger"> *</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="newViewName"
                                    value={newViewName}
                                    onChange={this.handleChange}
                                    onKeyDown={this.handleKeyDown}
                                />
                            </div>
                            {!this.state.isRenameView && (
                                <div className="col-12 mt-3">
                                    <MenuItem
                                        onClick={() => this.toggleItem('isDateSave')}
                                        style={{ paddingLeft: '0px' }}
                                    >
                                        <Checkbox checked={this.state.isDateSave} /> Save Current Dates
                                    </MenuItem>
                                </div>
                            )}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={this.saveView} disabled={!this.state.newViewName}>
                            Save
                        </Button>
                    </Modal.Footer>
                </ModalStyled>

                <ModalStyled
                    show={showAllGridViews}
                    onHide={() => this.openAllGridViews(false)}
                    className="modal-container custom-map-modal"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>All saved views</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <AllGridViews
                            gridViews={userSetting.grid_views}
                            openRenameView={this.openRenameView}
                            openDelteView={this.openDeleteView}
                            updategridViews={this.updategridViews}
                            updateViews={this.updateViews}
                        />
                    </Modal.Body>
                </ModalStyled>
            </div>
        );
    }
}

export default ClinicStateReportsGrid;
